import React from 'react';
import { eEditSingleFieldInputType } from './eEditSingleFieldInputType';
import { ModalWindow } from '../../../components';
import { EditSingleFieldDataEntry } from './EditSingleFieldDataEntry';

export interface IEditSingleFieldModalProps {
  disableSubmitButton: boolean;
  displayLabel: string;
  inputType: eEditSingleFieldInputType;
  onClose: () => void;
}

export const EditSingleFieldModal: React.FC<IEditSingleFieldModalProps> = ({
  displayLabel,
  disableSubmitButton,
  inputType,
  onClose,
}) => {
  return (
    <ModalWindow uitype={'medium'} title={`Edit ${displayLabel}`} onClose={onClose}>
      <EditSingleFieldDataEntry
        displayLabel={displayLabel}
        inputType={inputType}
        onClose={onClose}
        disableSubmitButton={disableSubmitButton}
      />
    </ModalWindow>
  );
};
